import React, { useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
} from '@material-ui/core';
import styles from './Footer.module.scss';
import { useHistory } from 'react-router-dom';

const Footer: React.FC = () => {
    const [isShowTermOfService, setIsShowTermOfService] = useState<boolean>(false);
    const history = useHistory();

    return (
        <>
            <div className={`${styles.Footer}`}>
                <div className={styles.CopyRight}>
                    <Typography>Copyright © NAL Japan 2021</Typography>
                </div>
                <div>|</div>
                {/* <div className={`${styles.Link}`} onClick={() => history.push('/')}>
                    <span>COMAについて</span>
                </div>
                <div>|</div>*/}
                <div className={`${styles.Link}`} onClick={() => setIsShowTermOfService(true)}>
                    <span>利用規約</span>
                </div>
            </div>

            <Dialog
                open={isShowTermOfService}
                onClose={() => setIsShowTermOfService(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className={styles.TermsOfServiceDialog}
            >
                {/* <DialogTitle className={styles.TermsOfServiceTitle}>利用規約</DialogTitle> */}
                <DialogContent className={styles.TermsOfServiceContent}>
                    <div>
                        <h1>利用規約</h1>
                    </div>
                    <div>
                        <div>
                            株式会社 NAL
                            JAPAN（以下「弊社」といいます）は、お客様に、以下の条件でCOMA(以下「本ソフト」)の使用を許諾します。
                        </div>
                        <div>
                            <div>
                                <span className={styles.Main}>第１条 (契約の成立)</span>
                                　お客様が、本件ソフトウェアの全部又は一部をコンピュータのハードディスク等の記憶装置へ保存したとき、又は本件ソフトウェアを使用したときは、本契約の締結に同意したものとみなされ、本契約は成立し効力を生ずるものとします。
                            </div>
                        </div>
                        <div>
                            <div>
                                <span className={styles.Main}>第２条 (著作権の帰属)</span>
                                　本ソフトに関する著作権等の知的財産権は、すべて弊社に帰属します。
                            </div>
                        </div>
                        <div>
                            <div>
                                <span className={styles.Main}>第３条 (使用権の許諾)</span>
                            </div>
                            <ul>
                                <li>
                                    弊社は、お客様に対し、本契約の条項に従って、本ソフトを使用する非独占的な権利を許諾します。
                                </li>
                                <li>
                                    お客様は、お客様のコンピュータに搭載されたハードディスクその他の記憶装置に本ソフトをインストールし、使用することができます。
                                </li>
                            </ul>
                        </div>

                        <div>
                            <div>
                                <span className={styles.Main}>第４条 (禁止事項)</span>
                            </div>
                            <ul>
                                <li>お客様は、本ソフトの全部又は一部を複製することはできません</li>
                                <li>
                                    お客様は、本ソフトの改変、リバースエンジニアリング、逆コンパイル又は逆アセンブルをすることはできません。
                                </li>
                                <li>
                                    お客様には、第三者に対し本ソフトの使用を許諾し、又は第三者に対し本ソフトを販売、貸与若しくはリースすることはできません。
                                </li>
                            </ul>
                        </div>

                        <div>
                            <div>
                                <span className={styles.Main}>第５条 (免責)</span>
                            </div>
                            <ul>
                                <li>
                                    弊社は、お客様に対し、本ソフトに関して、その動作、商品性、特定用途への適合性その他一切の保証を行いません。
                                </li>
                                <li>
                                    弊社は、お客様及び第三者が本ソフトに関連して直接又は間接に被ったいかなる損害についても、一切責任を負いません。お客様は、本ソフトの使用に関連して第三者からお客様になされた請求に関連する損害、損失あるいは責任より弊社を免責するものとします。
                                </li>
                            </ul>
                        </div>

                        <div>
                            <div>
                                <span className={styles.Main}>第６条 (契約の終了)</span>
                            </div>
                            <ul>
                                <li>
                                    お客様は、本ソフトをコンピュータのハードディスク等の記憶装置及びメモリーからすべて消去することにより、本契約を終了させることができます。
                                </li>
                                <li>
                                    お客様が本契約のいずれかの条項に違反したときは、弊社は、お客様に対し何らの通知、催告を行うことなく直ちに本契約を終了させることができます。
                                </li>
                            </ul>
                        </div>

                        <div>
                            <div>
                                <span className={styles.Main}>第７条 (合意管轄)</span>
                                　本契約に関する一切の紛争については、東京地方裁判所を第一審の専属管轄裁判所とします。
                            </div>
                        </div>
                        <div>
                            <div className={styles.Final}>以　上</div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default Footer;
